import {getTaxesInformation} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useTaxesInformation = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_TAXES_INFORMATION'], queryFn: getTaxesInformation}],
  })

  const {taxesinformationJsonSchema, taxesinformationUISchema} = results?.[0]?.data || {}

  return {
    taxesinformationJsonSchema,
    taxesinformationUISchema,
  }
}
